import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { RequestIndentCRUD } from '../services/requestIndentService';

const useIssuedIndentCRUD = (callMessage) => {
    const processIndent = useCallback(async (selectedMode, editIssueIndentID, requestBody) => {
        try {
            const apiEndpoint = selectedMode === 0
                ? API_ENDPOINTS.ISSUED_INDENT_CRUD_PROCESS
                : API_ENDPOINTS.RETURN_INDENT_CRUD_PROCESS;

            const successMessage = selectedMode === 0
                ? (editIssueIndentID !== 0 
                    ? 'Issued indent updated Successfully' 
                    : 'New Issued indent Created Successfully')
                : 'Issued indent Approved Successfully';

            // Await the API response
            const data = await RequestIndentCRUD(apiEndpoint, requestBody);
            
            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
                 return true; // ✅ SUCCESS
            } else {
                callMessage('error', 'No data received from API', 'Error');
                return false; // ❌ FAILURE
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
            return false; // ❌ FAILURE
        }
    }, [callMessage]);

    return { processIndent };
};

export default useIssuedIndentCRUD;

